<template>
  <div id="customVueTelInput" :class="className">
    <vue-tel-input
      v-model="phoneNum"
      id="the-tele-input"
      class="relative mt-2"
      :style="`border-color:${isError ? '#ed0d0d' : '#E6E6E6'}`"
      mode="international"
      :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true, tabindex: 1 }"
      v-bind="bindPropsUserInfo"
      :maxLen="10"
      :inputOptions="{ placeholder: placeholder || $t('user.auth.phone_number'), showDialCode: true }"
      @input="onPhoneNumberChange"
    >
      <template v-slot:arrow-icon> <div class="h-full border-r text-gray-800"></div> </template
    ></vue-tel-input>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

export default {
  components: {
    VueTelInput,
  },
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    placeholder: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      bindPropsUserInfo: {
        mode: "international",
        // defaultCountry: "EG",
        disabledFetchingCountry: true,
        disabled: false,
        // disabledFormatting: false,
        autoFormat: false,
        // placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: false,
        enabledFlags: false,
        // preferredCountries: ["AU", "BR"],
        onlyCountries: ["EG"],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 11,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabledDialCode: false,
          showFlags: true,
          showDialCodeInSelection: false,
          tabindex: 1,
          // disabled: true,
        },
      },
      phoneNum: "",
      phone: "",
    };
  },
  methods: {
    onPhoneNumberChange(e) {
      this.phoneNum = e.target.value.replace(/\D/g, ""); //check if there are char not a number -- then remove it
      this.phone = e.target.value.replace(/\D/g, ""); //check if there are char not a number -- then remove it
      this.onChange(this.phone);
      //max len for displaying
      const vue_tel_input = document.getElementsByClassName("vti__input");
      vue_tel_input[0].setAttribute("maxlength", "11");
    },
  },
  mounted() {
    this.$nextTick(() => {
      const arrow = document.querySelector("#vti__dropdown-arrow");
      arrow.textContent = "|";
    });
  },
};
</script>

<style  scoped >
#customVueTelInput .vue-tel-input {
  background-color: #cfcfcf56;
  outline: 2px solid transparent;
  border-width: 1px;
  border-radius: 5px;
  width: 100%;
}
#customVueTelInput .vue-tel-input .vti__input {
  background-color: #e8e8e83f;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border-width: 1px;
  border-color: rgb(158, 16, 16);
  color: rgb(17 24 39);
  border-radius: 5px;
  width: 100%;
  padding-right: 0.75rem;
  padding: 0.625rem;
  font-size: small;
}
#customVueTelInput .vue-tel-input:focus-within {
  border: 1px solid rgb(59 130 246);
  box-shadow: none;
}
</style>
